import parseRange from '../utility/parseRange';
/**
 * It normalizes the campaignId and range
 * @param {string} campaignId - The campaign ID
 * @param {string} range - Range of the stats
 * @returns {Object} params which is normalized version of range and campaignId
 * @returns {string} params.itemId which is the campaignId
 * @returns {string} params.range which is the range
 */
export default function campaignIdAndRangeNormalizer(campaignId, range) {
  return {
    itemId: campaignId,
    ...parseRange(range),
  };
}
